import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import * as fromModel from '../../services/models/';
import { Constant } from '../../../environments/constants';
import { Utils } from '../../../utils/utils';


export const INIT_APP_CONTEXT: fromModel.IAppContext = {
  action: fromModel.APP_ACTION.NONE,
  actionDispatchedBy: 'Initial',
  actionHistory: [],
  LegalEntityID: '',
  LegalEntityName: '',
  Clients: [],
  Account: [],
  SelectedAccounts: [],
  SelectedExternalAccounts: [], 
  SelectedLiabilities: [],
  SelectedExternalLiabilities: [],
  PlanId: '',
  PlanName: ''  
};

@Injectable({
  providedIn: 'root'
})
export class ContextService {

  protected contextSubject: BehaviorSubject<fromModel.IAppContext>;
  public context: fromModel.IAppContext;  

  constructor() { 
    this.context = JSON.parse(JSON.stringify(INIT_APP_CONTEXT));
    this.contextSubject = new BehaviorSubject<fromModel.IAppContext>(this.context);
  }

  public subscribe(callback: (context: fromModel.IAppContext) => void): Subscription{
    return this.contextSubject.subscribe(callback);    
  }

  public dispatchAction(act: string, dispatchedBy: string, payload: any | null): void {
    console.log(`%c App Context - Action: ${act}; By: ${dispatchedBy}`, Constant.consoleLogStyle.appContext);
    this.context.action = <fromModel.APP_ACTION>act;
    this.context.actionDispatchedBy = dispatchedBy;
    this.context.actionHistory.push(`${act}: ${dispatchedBy}`);
    let _contextUpdateReq = true;
    let accounts = [];
    let externalAccounts = [];
    let liabilities = [];
    let externalLiabilities = [];
   
    switch (<fromModel.APP_ACTION>act){
      case fromModel.APP_ACTION.NONE:
        console.log('%c App Context - No Action', Constant.consoleLogStyle.appContext);
        break;

      case fromModel.APP_ACTION.RESET:  
        console.log('%c Reset App Context', Constant.consoleLogStyle.appContext);
        this.context = JSON.parse(JSON.stringify(INIT_APP_CONTEXT));      
        break;

      // case fromModel.APP_ACTION.CLIENT:
      //   this.context.Clients = [];
        
      //   this.context.LegalEntityID = payload.LegalEntityID;
      //   this.context.LegalEntityName =  payload.LegalEntityName;         
      //   this.context.Clients.push(this.prepareClientData(payload, fromModel.CLIENTROLE.Primary));        

      //   if(payload.Account && payload.Account.length>0){ //Internal Accounts
      //     payload.Account.forEach(intAccId => {
      //       accounts.push(intAccId);
      //     });          
      //   }        
      //   if(payload.externalAccounts && payload.externalAccounts.length>0){ //External Accounts
      //     payload.externalAccounts.forEach(extAcc => {
      //       accounts.push(extAcc.accountId);
      //     });
      //   }
      //   this.context.Account = accounts;
                
      //   this.context.SelectedAccounts = payload.Account;
      //   this.context.SelectedExternalAccounts = [];   

      //   this.context.SelectedLiabilities = payload.Account;
      //   this.context.SelectedExternalLiabilities = [];   
      //   break; 

      case fromModel.APP_ACTION.CLIENT:
        this.context.Clients = [];
        
        this.context.LegalEntityID = payload.client.LegalEntityID;
        this.context.LegalEntityName =  payload.client.LegalEntityName;         
        this.context.Clients.push(this.prepareClientData(payload.client, fromModel.CLIENTROLE.Primary));        

        if(payload.client.Account && payload.client.Account.length>0){ //Internal Accounts
          payload.client.Account.forEach(intAccId => {
            accounts.push(intAccId);
          });          
        }        
        if(payload.client.externalAccounts && payload.client.externalAccounts.length>0){ //External Accounts
          payload.client.externalAccounts.forEach(extAcc => {
            accounts.push(extAcc.accountId);
          });
        }
        this.context.Account = accounts;

        let selectedAccounts = [];
        if(payload.accounts && payload.accounts.length>0){ 
          payload.accounts.forEach(acc => {
            selectedAccounts.push(acc.id);
          });
        }                
        this.context.SelectedAccounts = selectedAccounts;
        this.context.SelectedExternalAccounts = [];   

        let selectedLiabilities = [];
        if(payload.liabilities && payload.liabilities.length>0){ 
          payload.liabilities.forEach(acc => {
            selectedLiabilities.push(acc.id);
          });
        }                
        this.context.SelectedLiabilities = selectedLiabilities;
        this.context.SelectedExternalLiabilities = [];   
        break; 

      case fromModel.APP_ACTION.SELECTEDACCOUNTS:
        this.context.SelectedAccounts = payload.selectedAccounts;
        this.context.SelectedExternalAccounts = payload.selectedEAAccounts;
        break;
      case fromModel.APP_ACTION.SELECTEDLIABILITIES:
        this.context.SelectedLiabilities = payload.selectedLiabilities;
        this.context.SelectedExternalLiabilities = payload.selectedEALiabilities;
        break;
      case fromModel.APP_ACTION.ACCOUNT:
        this.context.Account = payload;
        break;
      case fromModel.APP_ACTION.INFLIGHTPLAN:
      case fromModel.APP_ACTION.PLAN:
          this.context.PlanId = payload.id;
          this.context.PlanName = payload.planName;
          this.context.Clients = payload.planClients;
          
          if(payload.planAccounts && payload.planAccounts.length>0){
            payload.planAccounts.forEach(acc => {
              if(acc.custodian === fromModel.CUSTODIANTYPE.HypoEA){
                externalAccounts.push(acc.actNo);
              } else {
                accounts.push(acc.actNo);
              }            
            });
          }
          this.context.SelectedAccounts = accounts;
          this.context.SelectedExternalAccounts = externalAccounts;

          if(payload.planLiabilities && payload.planLiabilities.length>0){
            payload.planLiabilities.forEach(acc => {
              if(acc.custodian === fromModel.CUSTODIANTYPE.HypoEA){
                externalLiabilities.push(acc.actNo);
              } else {
                liabilities.push(acc.actNo);
              }                        
            });
          }
          this.context.SelectedLiabilities = liabilities;
          this.context.SelectedExternalLiabilities = externalLiabilities;
          
          this.context.Account = accounts;
          this.context.LegalEntityID = this.getPrimaryClient().clientid;
          this.context.LegalEntityName = this.getPrimaryClient().clientname;
          break;
    }   
    
    // console.log(JSON.stringify(this.context));  
    const dispatchedContext: fromModel.IAppContext = JSON.parse(JSON.stringify(this.context));    
    this.contextSubject.next(dispatchedContext);    
  }

  prepareClientData(cl, role) {
    let _age = Utils.calculateAge(cl.dateofBirth);
    let data = {
                clientid: cl.LegalEntityID, 
                clientname: cl.LegalEntityName, 
                dob: cl.dateofBirth,
                age: _age,
                endAge: fromModel.DEFAULTS.endAge, 
                role: role, 
                retAge: fromModel.DEFAULTS.retAge
               }
    return data;
  }

  public getPrimaryClient(): fromModel.PlanClient {
    let client:  fromModel.PlanClient = null;
    if(this.context && this.context.Clients && this.context.Clients.length>0){
      client =  this.context.Clients.find(cl=> cl.role === fromModel.CLIENTROLE.Primary);
    }
    return client;
  }

  public getSecondaryClient(): fromModel.PlanClient {
    let client:  fromModel.PlanClient = null;
    if(this.context && this.context.Clients && this.context.Clients.length>0){
      client =  this.context.Clients.find(cl=> cl.role === fromModel.CLIENTROLE.Secondary);
    }
    return client;
  }
}
